import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import {
  Button,
  Flex,
  Space,
  Input,
  Dropdown,
  message,
  Spin,
  Modal,
  Empty,
  Row,
  Col,
  Result,
} from "antd";
import Markdown from "@sui/chat-ui/es/ChatUI/components/markdown";
import axios from "axios";
import API from "@/api";
import { DownOutlined } from "@ant-design/icons";

function SjjdData(props) {
  const { question_id, title } = props;
  const [data, setData] = useState("");
  const [jdData, setJdData] = useState("");
  const [spinning, setSpinning] = useState(true);
  const [exportLoading, setExportLoading] = useState(true);
  const [temps, setTemps] = useState([]);
  const [tempOpen, setTempOpen] = useState(false);
  const [activeKey, setActiveKey] = useState("");
  const [markdownSpinning, setMarkdownSpinning] = useState(true);
  const [init, setInit] = useState(false);
  const [choosedTemp, setChoosedTemp] = useState("");
  useEffect(() => {
    getSjjdTemps();
  }, []);

  const getSjjdTemps = () => {
    axios
      .post(API.getSjjdTemps, {
        questionId: question_id,
      })
      .then((res) => {
        const data = res?.data?.data?.thinking_text || "";
        const temps = res?.data?.data?.thinking_templates || [];
        setData(data);
        setTemps(temps);
        setSpinning(false);
      });
  };

  // 用于保存 AbortController 实例，以便随时调用 abort()
  const controllerRef = useRef(null);
  // 用于判断当前是否正在请求，控制按钮状态
  const [isStreaming, setIsStreaming] = useState(false);

  useEffect(() => {
    if (isStreaming) {
      setExportLoading(true);
    }
  }, [isStreaming]);

  const handleStreamRequest = async () => {
    setExportLoading(true);
    if (isStreaming) return;
    const url = API.sjjdAction;
    const payload = {
      question_id: question_id,
      thinking_text: data,
    };

    // 1. 创建一个新的 AbortController
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    try {
      setIsStreaming(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // 如果需要鉴权
          // 'Authorization': 'Bearer token'
        },
        body: JSON.stringify(payload),
        signal: signal, // 2. 将 signal 绑定到 fetch 请求
      });

      if (!response.ok) throw new Error("Network response was not ok");
      setInit(true);
      setTimeout(() => {
        setMarkdownSpinning(false);
      }, 500);
      // 1. 获取读取器
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let resultText = "";

      // 2. 循环读取流
      while (true) {
        const { done, value } = await reader.read();
        if (done) break; // 读取完毕

        // 3. 解码二进制数据
        const chunk = decoder.decode(value, { stream: true });
        // chunk 可能是多行数据，需要按换行符分割
        const lines = chunk.split("\n");

        lines.forEach((line) => {
          if (line.trim().startsWith("data:")) {
            // 去掉 'data:' 前缀
            const jsonString = line.replace(/^data:/, "").trim();
            if (jsonString === "[DONE]") return; // 结束标志

            try {
              const json = JSON.parse(jsonString);
              // 4. 提取增量内容 (delta) 并追加到结果中
              if (json.data && json.data.delta) {
                resultText += json.data.delta;
                // 更新页面显示 (例如 React 的 setState)
                setJdData(resultText);
              }
            } catch (e) {
              console.error("解析 JSON 失败:", e);
            }
          }
        });
      }
    } catch (error) {
      // 4. 捕获 abort 错误
      if (error.name === "AbortError") {
        console.log("用户手动停止了请求");
        message.info("解读已停止");
      } else {
        console.error("请求失败:", error);
        message.error("解读请求失败");
      }
    } finally {
      // 5. 无论成功、失败还是停止，都重置状态
      setIsStreaming(false);
      setExportLoading(false);
      controllerRef.current = null;
    }
  };

  const handleStop = () => {
    // 如果当前正在请求，则调用 abort 方法
    if (controllerRef.current) {
      controllerRef.current.abort();
      setExportLoading(false);
      // 注意：这里不需要手动 setIsStreaming(false)，
      // 因为 abort 会触发 catch 块，catch 块会在 finally 中重置状态
    }
  };

  return (
    <div className="sjjd">
      <div className="temp">
        <div className="action">
          <Flex justify="space-between" align="center">
            <div className="title">解读思路</div>
            <div className="btns">
              <Space>
                <Button
                  onClick={() => {
                    setJdData("");
                    getSjjdTemps();
                    setSpinning(true);
                  }}
                >
                  重置
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    setTempOpen(true);
                  }}
                >
                  模板选择
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    handleStreamRequest();
                    setInit(false);
                    setMarkdownSpinning(true);
                  }}
                >
                  开始解读
                </Button>
              </Space>
            </div>
          </Flex>
        </div>
        <div className="content">
          <Spin spinning={spinning}>
            <Input.TextArea
              autoSize={{
                minRows: 5,
                maxRows: 5,
              }}
              value={data}
              onChange={(val) => {
                setData(val?.target?.value);
              }}
            />
          </Spin>
        </div>
      </div>
      <div className="sjjdContent">
        {init ? (
          <Spin
            style={{
              minHeight: "300px",
            }}
            spinning={markdownSpinning}
          >
            <Markdown
              data={{
                think: null,
                thinking: false,
                content: jdData,
              }}
            ></Markdown>
          </Spin>
        ) : (
          <Result
            status={undefined}
            icon={null}
            subTitle="请点击开始解读按钮"
          />
        )}
      </div>
      <div className="acitons">
        <Space>
          <Dropdown.Button
            disabled={exportLoading}
            arrow={true}
            icon={<DownOutlined />}
            menu={{
              items: [
                {
                  key: "pdf",
                  label: "导出PDF",
                },
                {
                  key: "docx",
                  label: "导出Word",
                },
              ],
              onClick: (e) => {
                const format = e?.key === "pdf" ? "pdf" : "docx";
                const hide = message.loading("正在生成文件...", 0);
                axios
                  .post(
                    API.exportSjjdReport,
                    {
                      format,
                      report_markdown: jdData,
                      report_title: title,
                    },
                    {
                      // --- 关键配置 ---
                      responseType: "blob", // 必须设置为 blob，否则无法识别二进制文件流
                      headers: {
                        "Content-Type": "application/json", // 确保发送的是 JSON
                      },
                    },
                  )
                  .then((response) => {
                    // 3. 处理下载
                    // 从响应头中获取文件名（可选，如果后端设置了 Content-Disposition）
                    const disposition = response.headers["content-disposition"];
                    let fileName = `${title}.${format}`;

                    if (disposition) {
                      const match = disposition.match(/filename=(.+)$/);
                      if (match && match[1]) {
                        fileName = decodeURIComponent(match[1]);
                      }
                    }

                    // 创建隐藏的 <a> 标签触发下载
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(response.data);
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();

                    // 清理资源
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);

                    message.success("导出成功");
                  })
                  .catch((error) => {
                    console.error(error);
                    // 4. 错误处理
                    // 如果是 4xx/5xx 错误，blob 可能包含错误信息，这里简单处理为提示失败
                    message.error("导出失败，请稍后重试");
                  })
                  .finally(() => {
                    // 5. 关闭 Loading
                    hide();
                  });
              },
            }}
          >
            导出报告
          </Dropdown.Button>
          <Button onClick={handleStop} disabled={!isStreaming}>
            停止解读
          </Button>
        </Space>
      </div>
      <Modal
        title="解读思路模板"
        className="tempsModal"
        open={tempOpen}
        destroyOnHidden
        onCancel={() => {
          setTempOpen(false);
        }}
        width={"600px"}
        footer={
          null
          // <>
          //   <Space>
          //     <Button
          //       onClick={() => {
          //         setTempOpen(false);
          //       }}
          //     >
          //       关闭
          //     </Button>
          //     <Button type="primary">确定</Button>
          //   </Space>
          // </>
        }
      >
        <div className="temps">
          <Row gutter={[0, 16]}>
            {temps && temps.length ? (
              temps.map((item) => {
                return (
                  <Col span={24}>
                    <div
                      key={item.key}
                      className={`listItem ${
                        activeKey === item.key ? "active" : ""
                      } `}
                      onClick={() => {
                        setData(item.thinking_text);
                        setActiveKey(item.key);
                        setTempOpen(false);
                      }}
                    >
                      {item.thinking_text}
                    </div>
                  </Col>
                );
              })
            ) : (
              <Empty />
            )}
          </Row>
        </div>
         
      </Modal>
    </div>
  );
}

export default SjjdData;
